import { render } from "./purchase_panel.vue?vue&type=template&id=81c8cd16&scoped=true"
import script from "./purchase_panel.vue?vue&type=script&lang=js"
export * from "./purchase_panel.vue?vue&type=script&lang=js"

import "./purchase_panel.vue?vue&type=style&index=0&id=81c8cd16&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c8cd16"]])

export default __exports__